import { getConfigApi } from '../config'
import { getFetch, postFetch } from '../utils/fetch'

function getAuthUrl(prefix = '') {
  return getConfigApi().auth + '/' + prefix
}

export function loginUser(data = {}) {
  return postFetch(getAuthUrl('login'), data)
}

export function getMe() {
  return getFetch(getAuthUrl('me'))
}

export default {
  loginUser,
  getMe
}



// WEBPACK FOOTER //
// ./src/api/AuthApi.js